import { Component, Inject } from '@angular/core';
import { IPluginPreviewComponent } from '../../../../../../interfaces/plugin-preview-component.interface';
import { RequisitionData } from '../../../../../../models/wizard-plugin-models/requisition-data';
import { ErrorHandlerService } from '../../../../../../decoration-base/error-handler.service';
import { CUSTOMER_ENTITY_SERVICE_TOKEN } from '../../../../../../injection-tokens/entity-service-tokens';
import { ICustomerEntityService } from '../../../../../../interfaces/entities/customer-entity-service.interface';
import { ClassesEntity } from '../../../../../../models/entities/classes-entity';
import { CustomerDetails } from '../../../../../../models/entities/requisition-model';
import { CustomerEntity } from '../../../../../../models/entities/customer';

@Component({
  selector: 'app-requisition-preview',
  templateUrl: './requisition-preview.component.html',
  styleUrl: './requisition-preview.component.css'
})
export class RequisitionPreviewComponent implements IPluginPreviewComponent {

  public previewData: RequisitionData | undefined; // Replace 'any' with the actual type if known

  constructor(
    @Inject(CUSTOMER_ENTITY_SERVICE_TOKEN) private customerService: ICustomerEntityService,
    private errorHandler: ErrorHandlerService
  ) {
    // Don't call createForm here - FormBuilder might not be ready
  }

  setData(data: any): void {
    if (data) {
      this.previewData = data as RequisitionData;
      // this.previewData.customerDetails.name=this.customerGetbyById(this.previewData.customerDetails.id).name;
    }
  }

  customerGetbyById(customerId: string): any {
      const customerName = this.customerService.getCustomerById(customerId)!;
      return customerName;
      // return customer;
    }

}
